/**
 * Tasks Command Group
 * jai1 tasks (alias: jai1 t)
 */
import { Command } from 'commander';
import { TaskService } from '../../services/task.service.js';
import { createTaskAddCommand } from './add.js';
import { createTaskListCommand } from './list.js';
import { createTaskReadyCommand } from './ready.js';
import { createTaskUpdateCommand } from './update.js';
import { createTaskShowCommand } from './show.js';
import { createTaskPickCommand } from './pick.js';
import { createTaskDoneCommand } from './done.js';
import { createTaskDepCommand } from './dep.js';
import { createTaskSyncCommand } from './sync.js';
import { createTaskSummaryCommand } from './summary.js';
import { createTaskGuideCommand } from './guide.js';
import { createTaskParentsCommand } from './parents.js';
import { createTaskCancelCommand } from './cancel.js';
import { createTaskDeleteCommand } from './delete.js';

export function createTasksCommand(): Command {
    const cmd = new Command('tasks')
        .alias('t')
        .description('Task management — track, assign, and manage development tasks')
        .hook('preAction', (thisCommand, actionCommand) => {
            // Skip .jai1 check for 'guide' command (informational only)
            if (actionCommand.name() !== 'guide') {
                TaskService.ensureJai1Dir();
            }
        });

    cmd.addCommand(createTaskListCommand());
    cmd.addCommand(createTaskReadyCommand());
    cmd.addCommand(createTaskAddCommand());
    cmd.addCommand(createTaskUpdateCommand());
    cmd.addCommand(createTaskShowCommand());
    cmd.addCommand(createTaskPickCommand());
    cmd.addCommand(createTaskDoneCommand());
    cmd.addCommand(createTaskDepCommand());
    cmd.addCommand(createTaskSyncCommand());
    cmd.addCommand(createTaskSummaryCommand());
    cmd.addCommand(createTaskParentsCommand());
    cmd.addCommand(createTaskCancelCommand());
    cmd.addCommand(createTaskDeleteCommand());
    cmd.addCommand(createTaskGuideCommand());

    // Default action: show summary
    cmd.action(async () => {
        const { handleTaskSummary } = await import('./summary.js');
        await handleTaskSummary({ json: false });
    });

    return cmd;
}
